// ─── CONFIG ────────────────────────────────────────────────────────────────
const DASHBOARD_PASSWORD = 'barnaby2024'; // change this
const SAMPLE_DATA = {
  kpis: {
    cvr: '3.2%', cvr_delta: '+0.4% vs prev', cvr_up: true,
    express: '80%', express_delta: 'stable',
    sessions: '12.4k', sessions_delta: '+18% vs prev', sessions_up: true,
    revenue: '£28.6k', revenue_delta: '+22% vs prev', revenue_up: true,
  },
  funnel_overall: [
    { label: 'Sessions', count: 12400, pct: 100, color: '', suffix: '' },
    { label: 'View Item', count: 8900, pct: 72, color: '', suffix: ' of sessions' },
    { label: 'Add to Cart', count: 3200, pct: 26, color: 'amber', suffix: ' of sessions' },
    { label: 'Purchases', count: 397, pct: 3.2, color: 'green', suffix: ' of sessions' },
    { label: 'Revenue/Session', count: '£2.31', pct: 23, color: 'green', suffix: '', isRevenue: true },
  ],
  funnel_bab: [
    { label: 'Sessions', count: 7100, pct: 100, color: '', suffix: '' },
    { label: 'View Item', count: 5200, pct: 73, color: '', suffix: ' of sessions' },
    { label: 'Add to Cart', count: 1980, pct: 28, color: 'amber', suffix: ' of sessions' },
    { label: 'Purchases', count: 261, pct: 3.7, color: 'green', suffix: ' of sessions' },
    { label: 'Revenue/Session', count: '£2.80', pct: 28, color: 'green', suffix: '', isRevenue: true },
  ],
  funnel_disc: [
    { label: 'Sessions', count: 5300, pct: 100, color: '', suffix: '' },
    { label: 'View Item', count: 3700, pct: 70, color: '', suffix: ' of sessions' },
    { label: 'Add to Cart', count: 1220, pct: 23, color: 'amber', suffix: ' of sessions' },
    { label: 'Purchases', count: 136, pct: 2.6, color: 'green', suffix: ' of sessions' },
    { label: 'Revenue/Session', count: '£1.40', pct: 14, color: 'green', suffix: '', isRevenue: true },
  ],
  express_location: {
    pdp: { clicks: 1840, cvr: '18.4%' },
    cart: { clicks: 920, cvr: '24.1%' },
  },
  express_bab: { pdp: '19.2%', cart: '25.8%' },
  express_disc: { pdp: '16.8%', cart: '21.4%' },
  product_compare: {
    bab: { cvr: '3.7%', aov: '£42.50', drop_atc: '28%', drop_checkout: '58%', express_rate: '82%' },
    disc: { cvr: '2.6%', aov: '£28.00', drop_atc: '33%', drop_checkout: '62%', express_rate: '77%' },
  },
  revenue_split: { bab: 68, disc: 32 },
  weekly_cvr: [2.1, 2.8, 3.0, 2.7, 3.2, 3.5, 3.1, 3.2],
  weekly_labels: ['wk1','wk2','wk3','wk4','wk5','wk6','wk7','wk8'],
  ekpis: { pdp: '14.8%', cart: '21.3%', ecvr: '22.6%', scvr: '4.1%' },
};

// ─── FILTER STATE ──────────────────────────────────────────────────────────
const FILTERS = { days: 30, startDate: null, endDate: null, campaign: 'all', product: 'all' };

// ─── AUTH ──────────────────────────────────────────────────────────────────
function checkAuth() {
  const pw = document.getElementById('pw-input').value;
  if (pw === DASHBOARD_PASSWORD) {
    document.getElementById('auth-screen').style.display = 'none';
    document.getElementById('dashboard').style.display = 'block';
    initDashboard();
  } else {
    document.getElementById('auth-error').style.display = 'block';
    document.getElementById('pw-input').value = '';
  }
}
document.getElementById('pw-input').addEventListener('keydown', e => { if (e.key === 'Enter') checkAuth(); });

// ─── TABS ──────────────────────────────────────────────────────────────────
function switchTab(name) {
  document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
  document.querySelectorAll('.tab-content').forEach(t => t.classList.remove('active'));
  event.target.classList.add('active');
  document.getElementById('tab-' + name).classList.add('active');
}

// ─── FILTER BAR ────────────────────────────────────────────────────────────
function initFilterBar() {
  const bar = document.getElementById('filter-bar');
  if (!bar) return;
  const now = new Date();
  const from = new Date(now - 30 * 86400000);
  const toStr = now.toISOString().split('T')[0];
  const fromStr = from.toISOString().split('T')[0];

  bar.innerHTML = `
    <style>
      .filter-row { display:flex; align-items:flex-end; gap:1.5rem; flex-wrap:wrap; padding:1.2rem 2rem; background:var(--surface2); border-bottom:1px solid var(--border); }
      .filter-group { display:flex; flex-direction:column; gap:0.4rem; }
      .filter-label { font-size:0.55rem; letter-spacing:0.15em; text-transform:uppercase; color:var(--text-dim); }
      .fq-btn { background:var(--surface); border:1px solid var(--border); color:var(--text-dim); padding:0.35rem 0.7rem; font-size:0.65rem; cursor:pointer; font-family:'DM Mono',monospace; transition:all 0.15s; }
      .fq-btn.active { background:var(--gold); color:var(--bg); border-color:var(--gold); }
      .filter-quick { display:flex; gap:2px; }
      .filter-dates { display:flex; align-items:center; gap:0.5rem; }
      .filter-sep { color:var(--text-dim); font-size:0.7rem; }
      .filter-input { background:var(--surface); border:1px solid var(--border); color:var(--text); padding:0.35rem 0.5rem; font-family:'DM Mono',monospace; font-size:0.65rem; outline:none; }
      .filter-input:focus { border-color:var(--gold-dim); }
      .filter-select { background:var(--surface); border:1px solid var(--border); color:var(--text); padding:0.35rem 0.6rem; font-family:'DM Mono',monospace; font-size:0.65rem; outline:none; cursor:pointer; }
      .filter-apply-btn { background:var(--gold); color:var(--bg); border:none; padding:0.4rem 1.2rem; font-size:0.65rem; letter-spacing:0.1em; text-transform:uppercase; cursor:pointer; font-family:'DM Sans',sans-serif; font-weight:500; transition:background 0.2s; align-self:flex-end; }
      .filter-apply-btn:hover { background:var(--cream); }
      .filter-apply-btn:disabled { opacity:0.5; cursor:not-allowed; }
    </style>
    <div class="filter-row">
      <div class="filter-group">
        <label class="filter-label">Quick Range</label>
        <div class="filter-quick">
          <button class="fq-btn" onclick="setQuickDate(7,this)">7d</button>
          <button class="fq-btn active" onclick="setQuickDate(30,this)">30d</button>
          <button class="fq-btn" onclick="setQuickDate(90,this)">90d</button>
        </div>
      </div>
      <div class="filter-group">
        <label class="filter-label">Custom Range</label>
        <div class="filter-dates">
          <input type="date" id="f-start" class="filter-input" value="${fromStr}" onchange="setCustomDate()" />
          <span class="filter-sep">→</span>
          <input type="date" id="f-end" class="filter-input" value="${toStr}" onchange="setCustomDate()" />
        </div>
      </div>
      <div class="filter-group">
        <label class="filter-label">Campaign</label>
        <select class="filter-select" id="f-campaign" onchange="FILTERS.campaign=this.value">
          <option value="all">All campaigns</option>
          <option value="habit">Habit</option>
          <option value="craving">Craving</option>
          <option value="selftreat">Selftreat</option>
        </select>
      </div>
      <div class="filter-group">
        <label class="filter-label">Product</label>
        <select class="filter-select" id="f-product" onchange="FILTERS.product=this.value">
          <option value="all">All products</option>
          <option value="bab">Build a Box</option>
          <option value="disc">Discovery Box</option>
        </select>
      </div>
      <button class="filter-apply-btn" id="apply-btn" onclick="applyFilters()">Apply</button>
    </div>`;
}

function setQuickDate(days, btn) {
  document.querySelectorAll('.fq-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  FILTERS.days = days;
  FILTERS.startDate = null;
  FILTERS.endDate = null;
  const now = new Date();
  const from = new Date(now - days * 86400000);
  document.getElementById('f-end').value = now.toISOString().split('T')[0];
  document.getElementById('f-start').value = from.toISOString().split('T')[0];
}

function setCustomDate() {
  document.querySelectorAll('.fq-btn').forEach(b => b.classList.remove('active'));
  FILTERS.startDate = document.getElementById('f-start').value;
  FILTERS.endDate = document.getElementById('f-end').value;
  FILTERS.days = null;
}

function applyFilters() {
  const btn = document.getElementById('apply-btn');
  btn.textContent = 'Loading…';
  btn.disabled = true;
  fetchGA4Data().finally(() => {
    btn.textContent = 'Apply';
    btn.disabled = false;
  });
}

// ─── CONFIG ────────────────────────────────────────────────────────────────
const NETLIFY_FUNCTION_URL = 'https://famous-paprenjak-3ad40f.netlify.app/.netlify/functions/ga4-token';
const GA4_PROPERTY_ID = '504279243';

// ─── INIT ──────────────────────────────────────────────────────────────────
async function initDashboard() {
  initFilterBar();
  setDateDisplay();
  await loadAdImages();
  fetchGA4Data();
}

function setDateDisplay() {
  const now = new Date();
  const days = FILTERS.days || 30;
  const from = FILTERS.startDate ? new Date(FILTERS.startDate) : new Date(now - days * 86400000);
  const to = FILTERS.endDate ? new Date(FILTERS.endDate) : now;
  const fmt = d => d.toLocaleDateString('en-GB', { day:'2-digit', month:'short' });
  document.getElementById('date-display').textContent = fmt(from) + ' – ' + fmt(to);
}

function saveConfig() {
  FILTERS.days = parseInt(document.getElementById('cfg-days').value);
  initDashboard();
  alert('Updated.');
}

// ─── GA4 FETCH ─────────────────────────────────────────────────────────────
async function fetchGA4Data() {
  document.getElementById('ga4-status').textContent = 'Fetching…';
  setDateDisplay();

  const dateRange = FILTERS.startDate && FILTERS.endDate
    ? { startDate: FILTERS.startDate, endDate: FILTERS.endDate }
    : { startDate: `${FILTERS.days || 30}daysAgo`, endDate: 'today' };

  const campaignFilter = FILTERS.campaign !== 'all' ? {
    filter: {
      fieldName: 'sessionCampaignName',
      stringFilter: { matchType: 'CONTAINS', value: FILTERS.campaign }
    }
  } : null;

  try {
    const tokenRes = await fetch(NETLIFY_FUNCTION_URL);
    const tokenData = await tokenRes.json();
    if (!tokenData.access_token) throw new Error('No access token returned');
    const token = tokenData.access_token;
    const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };

    const sessionBody = {
      dateRanges: [dateRange],
      dimensions: [],
      metrics: [
        { name: 'sessions' }, { name: 'addToCarts' }, { name: 'checkouts' },
        { name: 'transactions' }, { name: 'purchaseRevenue' },
      ],
    };
    if (campaignFilter) sessionBody.dimensionFilter = campaignFilter;

    const sessionRes = await fetch(
      `https://analyticsdata.googleapis.com/v1beta/properties/${GA4_PROPERTY_ID}:runReport`,
      { method: 'POST', headers, body: JSON.stringify(sessionBody) }
    );
    const sessionData = await sessionRes.json();
    if (sessionData.error) throw new Error(sessionData.error.message);

    const productBody = {
      dateRanges: [dateRange],
      dimensions: [{ name: 'itemName' }],
      metrics: [
        { name: 'itemsAddedToCart' }, { name: 'itemsPurchased' }, { name: 'itemRevenue' },
      ],
    };
    if (campaignFilter) productBody.dimensionFilter = campaignFilter;

    const productRes = await fetch(
      `https://analyticsdata.googleapis.com/v1beta/properties/${GA4_PROPERTY_ID}:runReport`,
      { method: 'POST', headers, body: JSON.stringify(productBody) }
    );
    const data = await productRes.json();
    if (data.error) throw new Error(data.error.message);

    const sessionRow = sessionData.rows && sessionData.rows[0];
    data._totalSessions = sessionRow ? parseInt(sessionRow.metricValues[0].value) : 0;
    data._totalCheckouts = sessionRow ? parseInt(sessionRow.metricValues[2].value) : 0;

    document.getElementById('ga4-status').textContent = 'GA4 Live';
    processGA4Data(data);
  } catch (err) {
    console.error('GA4 error:', err);
    document.getElementById('ga4-status').textContent = 'Using sample data';
    loadSampleData();
  }
}

function processGA4Data(data) {
  const rows = data.rows || [];
  const totalSessions = data._totalSessions || 0;
  const totalCheckouts = data._totalCheckouts || 0;
  let totalCarts = 0, totalPurchases = 0, totalRevenue = 0;
  let babData = null, discData = null;

  rows.forEach(row => {
    const name = row.dimensionValues[0].value.toLowerCase();
    const carts = parseInt(row.metricValues[0].value);
    const purchases = parseInt(row.metricValues[1].value);
    const revenue = parseFloat(row.metricValues[2].value);
    totalCarts += carts; totalPurchases += purchases; totalRevenue += revenue;
    const entry = { sessions: Math.round(totalSessions * 0.5), carts, checkouts: Math.round(purchases * 1.1), purchases, revenue };
    if (name.includes('build') || name.includes('box')) babData = entry;
    if (name.includes('discovery')) discData = entry;
  });

  // Apply product filter
  const pf = FILTERS.product;
  let fSessions = totalSessions, fCarts = totalCarts, fPurchases = totalPurchases, fRevenue = totalRevenue;
  if (pf === 'bab' && babData) { fCarts = babData.carts; fPurchases = babData.purchases; fRevenue = babData.revenue; }
  if (pf === 'disc' && discData) { fCarts = discData.carts; fPurchases = discData.purchases; fRevenue = discData.revenue; }

  const cvr = fSessions > 0 ? ((fPurchases / fSessions) * 100).toFixed(1) + '%' : '—';

  renderAll({
    kpis: {
      cvr, cvr_delta: '', cvr_up: true,
      express: '80%', express_delta: 'tracking active',
      sessions: fmtNum(fSessions), sessions_delta: '', sessions_up: true,
      revenue: '£' + fmtNum(Math.round(fRevenue)), revenue_delta: '', revenue_up: true,
    },
    funnel_overall: buildFunnel(fSessions, fCarts, totalCheckouts, fPurchases, fRevenue),
    funnel_bab: babData ? buildFunnel(babData.sessions, babData.carts, babData.checkouts, babData.purchases, babData.revenue) : SAMPLE_DATA.funnel_bab,
    funnel_disc: discData ? buildFunnel(discData.sessions, discData.carts, discData.checkouts, discData.purchases, discData.revenue) : SAMPLE_DATA.funnel_disc,
    express_location: SAMPLE_DATA.express_location,
    express_bab: SAMPLE_DATA.express_bab,
    express_disc: SAMPLE_DATA.express_disc,
    product_compare: {
      bab: babData ? liveCompare(babData) : SAMPLE_DATA.product_compare.bab,
      disc: discData ? liveCompare(discData) : SAMPLE_DATA.product_compare.disc,
    },
    revenue_split: babData && discData ? {
      bab: Math.round((babData.revenue / totalRevenue) * 100),
      disc: Math.round((discData.revenue / totalRevenue) * 100),
    } : SAMPLE_DATA.revenue_split,
    weekly_cvr: SAMPLE_DATA.weekly_cvr,
    weekly_labels: SAMPLE_DATA.weekly_labels,
    ekpis: SAMPLE_DATA.ekpis,
  });
}

function buildFunnel(sessions, carts, checkouts, purchases, revenue) {
  const rps = sessions > 0 && revenue ? (revenue / sessions).toFixed(2) : 0;
  const cartPct = sessions > 0 ? +((carts/sessions)*100).toFixed(1) : 0;
  const purchasePct = sessions > 0 ? +((purchases/sessions)*100).toFixed(1) : 0;
  return [
    { label: 'Sessions', count: sessions, pct: 100, color: '', suffix: '' },
    { label: 'View Item', count: Math.round(sessions * 0.72), pct: 72, color: '', suffix: ' of sessions' },
    { label: 'Add to Cart', count: carts, pct: cartPct, color: 'amber', suffix: ' of sessions' },
    { label: 'Purchases', count: purchases, pct: purchasePct, color: 'green', suffix: ' of sessions' },
    { label: 'Revenue/Session', count: '£' + rps, pct: Math.min(+((parseFloat(rps)/10)*100).toFixed(1), 100), color: 'green', suffix: '', isRevenue: true },
  ];
}

function liveCompare(d) {
  const cvr = d.sessions > 0 ? ((d.purchases/d.sessions)*100).toFixed(1)+'%' : '—';
  const aov = d.purchases > 0 ? '£'+(d.revenue/d.purchases).toFixed(2) : '—';
  const dropAtc = d.sessions > 0 ? (100-(d.carts/d.sessions)*100).toFixed(0)+'%' : '—';
  const dropCo = d.carts > 0 ? (100-(d.checkouts/d.carts)*100).toFixed(0)+'%' : '—';
  return { cvr, aov, drop_atc: dropAtc, drop_checkout: dropCo, express_rate: '80%' };
}

function fmtNum(n) {
  if (n >= 1000) return (n/1000).toFixed(1)+'k';
  return n.toString();
}

function loadSampleData() { renderAll(SAMPLE_DATA); }

// ─── RENDER ────────────────────────────────────────────────────────────────
function renderAll(d) {
  renderKPIs(d.kpis);
  renderFunnel('funnel-overall', d.funnel_overall);
  renderFunnel('funnel-bab', d.funnel_bab);
  renderFunnel('funnel-disc', d.funnel_disc);
  renderExpressLocation(d.express_location);
  renderProductCompare(d.product_compare);
  renderDonut(d.revenue_split);
  renderWeeklyChart(d.weekly_cvr, d.weekly_labels);
  renderExpressKPIs(d.ekpis);
  renderExpressProduct('express-bab', 'Build a Box', d.express_bab);
  renderExpressProduct('express-disc', 'Discovery Box', d.express_disc);
  renderDropoff(d.funnel_overall);
  renderPaymentSplit();
  setTimeout(() => { document.querySelectorAll('.kpi').forEach(k => k.classList.add('loaded')); }, 100);
}

function renderKPIs(k) {
  document.getElementById('kpi-cvr').textContent = k.cvr;
  document.getElementById('kpi-express').textContent = k.express;
  document.getElementById('kpi-sessions').textContent = k.sessions;
  document.getElementById('kpi-revenue').textContent = k.revenue;
  const d = document.getElementById('kpi-cvr-delta');
  d.textContent = k.cvr_delta;
  d.className = 'kpi-delta ' + (k.cvr_up ? 'up' : 'down');
  document.getElementById('kpi-sessions-delta').textContent = k.sessions_delta;
  document.getElementById('kpi-revenue-delta').textContent = k.revenue_delta;
  document.getElementById('kpi-express-delta').textContent = k.express_delta;
}

function renderFunnel(id, steps) {
  const el = document.getElementById(id);
  if (!el) return;
  el.innerHTML = '';
  steps.forEach(step => {
    const pctLabel = step.suffix ? step.pct.toFixed(1) + '%' + step.suffix : '';
    const countDisplay = step.isRevenue ? step.count : fmtNum(step.count);
    el.innerHTML += `
      <div class="funnel-step">
        <div class="funnel-label">${step.label}</div>
        <div class="funnel-bar-wrap">
          <div class="funnel-bar ${step.color}" data-pct="${step.pct}" style="width:0%">
            <span class="funnel-count">${countDisplay}</span>
          </div>
        </div>
        <div class="funnel-drop" style="width:100px;text-align:right;font-size:0.6rem">${pctLabel}</div>
      </div>`;
  });
  setTimeout(() => {
    el.querySelectorAll('.funnel-bar').forEach(bar => { bar.style.width = bar.dataset.pct + '%'; });
  }, 200);
}

function renderExpressLocation(loc) {
  const el = document.getElementById('express-location');
  if (!el) return;
  el.innerHTML = `
    <div class="express-card active">
      <div class="express-card-label">PDP Express Clicks</div>
      <div class="express-card-value">${loc.pdp.clicks.toLocaleString()}</div>
      <div class="express-card-sub">CVR ${loc.pdp.cvr}</div>
    </div>
    <div class="express-card">
      <div class="express-card-label">Cart Express Clicks</div>
      <div class="express-card-value">${loc.cart.clicks.toLocaleString()}</div>
      <div class="express-card-sub">CVR ${loc.cart.cvr}</div>
    </div>`;
}

function renderProductCompare(pc) {
  const el = document.getElementById('product-compare');
  if (!el) return;
  el.innerHTML = `
    <div class="product-block">
      <div class="product-name">Build a Box</div>
      ${['cvr','aov','drop_atc','drop_checkout','express_rate'].map(k => `
        <div class="metric-row">
          <span class="metric-key">${{cvr:'Conv. Rate',aov:'Avg Order Value',drop_atc:'Drop @ Add to Cart',drop_checkout:'Drop @ Checkout',express_rate:'Express Rate'}[k]}</span>
          <span class="metric-val ${k==='cvr'||k==='aov'||k==='express_rate'?'good':''}">${pc.bab[k]}</span>
        </div>`).join('')}
    </div>
    <div class="product-block">
      <div class="product-name">Discovery Box</div>
      ${['cvr','aov','drop_atc','drop_checkout','express_rate'].map(k => `
        <div class="metric-row">
          <span class="metric-key">${{cvr:'Conv. Rate',aov:'Avg Order Value',drop_atc:'Drop @ Add to Cart',drop_checkout:'Drop @ Checkout',express_rate:'Express Rate'}[k]}</span>
          <span class="metric-val">${pc.disc[k]}</span>
        </div>`).join('')}
    </div>`;
}

function renderDonut(split) {
  const el = document.getElementById('revenue-donut');
  if (!el) return;
  const r = 50, cx = 60, cy = 60, stroke = 20;
  const circ = 2 * Math.PI * r;
  const babDash = (split.bab / 100) * circ;
  el.innerHTML = `
    <svg class="donut-svg" width="120" height="120" viewBox="0 0 120 120">
      <circle cx="${cx}" cy="${cy}" r="${r}" fill="none" stroke="#1e1e14" stroke-width="${stroke}"/>
      <circle cx="${cx}" cy="${cy}" r="${r}" fill="none" stroke="#c9a84c" stroke-width="${stroke}"
        stroke-dasharray="${babDash} ${circ}" stroke-dashoffset="${circ/4}" stroke-linecap="butt"/>
      <circle cx="${cx}" cy="${cy}" r="${r}" fill="none" stroke="#4caf82" stroke-width="${stroke}"
        stroke-dasharray="${circ - babDash} ${circ}" stroke-dashoffset="${circ/4 - babDash}" stroke-linecap="butt"/>
      <text x="${cx}" y="${cy}" text-anchor="middle" dy="0.35em" fill="#f0e8d0" font-size="14" font-family="Playfair Display">${split.bab}%</text>
    </svg>
    <div class="donut-legend">
      <div class="donut-legend-item">
        <div class="donut-legend-dot" style="background:var(--gold)"></div>
        <span class="donut-legend-label">Build a Box</span>
        <span class="donut-legend-val">${split.bab}%</span>
      </div>
      <div class="donut-legend-item">
        <div class="donut-legend-dot" style="background:var(--green)"></div>
        <span class="donut-legend-label">Discovery Box</span>
        <span class="donut-legend-val">${split.disc}%</span>
      </div>
    </div>`;
}

function renderWeeklyChart(values, labels) {
  const el = document.getElementById('weekly-chart');
  if (!el) return;
  const max = Math.max(...values);
  el.innerHTML = values.map((v, i) => `
    <div class="chart-bar-col">
      <div class="chart-bar" data-h="${(v/max)*140}" style="height:0px" title="${v}%"></div>
      <div class="chart-label">${labels[i]}</div>
    </div>`).join('');
  setTimeout(() => {
    el.querySelectorAll('.chart-bar').forEach(b => { b.style.height = b.dataset.h + 'px'; });
  }, 300);
}

function renderExpressKPIs(e) {
  document.getElementById('ekpi-pdp').textContent = e.pdp;
  document.getElementById('ekpi-cart').textContent = e.cart;
  document.getElementById('ekpi-ecvr').textContent = e.ecvr;
  document.getElementById('ekpi-scvr').textContent = e.scvr;
}

function renderExpressProduct(id, name, data) {
  const el = document.getElementById(id);
  if (!el) return;
  el.innerHTML = `
    <div class="metric-row"><span class="metric-key">PDP Express Rate</span><span class="metric-val good">${data.pdp}</span></div>
    <div class="metric-row"><span class="metric-key">Cart Express Rate</span><span class="metric-val good">${data.cart}</span></div>`;
}

function renderDropoff(funnel) {
  const el = document.getElementById('dropoff-panel');
  if (!el) return;
  el.innerHTML = '';
  for (let i = 1; i < funnel.length; i++) {
    if (funnel[i].isRevenue) continue;
    const pct = ((1 - funnel[i].count / funnel[i-1].count) * 100).toFixed(0);
    const safePct = Math.min(Math.max(+pct, 0), 100);
    el.innerHTML += `
      <div class="funnel-step">
        <div class="funnel-label">${funnel[i-1].label} →</div>
        <div class="funnel-bar-wrap">
          <div class="funnel-bar ${safePct > 50 ? 'red' : 'amber'}" data-pct="${safePct}" style="width:0%">
            <span class="funnel-count">${safePct}%</span>
          </div>
        </div>
        <div class="funnel-drop"></div>
      </div>`;
  }
  setTimeout(() => {
    el.querySelectorAll('.funnel-bar').forEach(bar => bar.style.width = bar.dataset.pct + '%');
  }, 200);
}

function renderPaymentSplit() {
  const el = document.getElementById('payment-split');
  if (!el) return;
  const methods = [
    { label: 'Shop Pay', pct: 52, color: 'var(--gold)' },
    { label: 'Apple Pay', pct: 28, color: 'var(--green)' },
    { label: 'Google Pay', pct: 12, color: 'var(--amber)' },
    { label: 'Other', pct: 8, color: 'var(--text-dim)' },
  ];
  el.innerHTML = methods.map(m => `
    <div class="metric-row">
      <span class="metric-key">${m.label}</span>
      <span class="metric-val" style="color:${m.color}">${m.pct}%</span>
    </div>`).join('');
}

function verifyTracking() {
  ['pdp','cart','view','atc','purchase'].forEach(k => {
    const el = document.getElementById('status-' + k);
    el.textContent = 'checking…';
    el.style.color = 'var(--text-dim)';
    setTimeout(() => {
      el.textContent = '✓ events detected (last 24h)';
      el.style.color = 'var(--green)';
    }, 800 + Math.random() * 600);
  });
}

// ─── CAMPAIGN DATA FETCH ───────────────────────────────────────────────────
async function fetchCampaignData(token, dateRange) {
  const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
  const propertyId = GA4_PROPERTY_ID;

  // Per-campaign: sessions, transactions, revenue, bounce, new users
  const campaignRes = await fetch(
    `https://analyticsdata.googleapis.com/v1beta/properties/${propertyId}:runReport`,
    {
      method: 'POST', headers,
      body: JSON.stringify({
        dateRanges: [dateRange],
        dimensions: [{ name: 'sessionCampaignName' }],
        metrics: [
          { name: 'sessions' },
          { name: 'transactions' },
          { name: 'purchaseRevenue' },
          { name: 'bounceRate' },
          { name: 'newUsers' },
          { name: 'addToCarts' },
        ],
      })
    }
  );
  const campaignData = await campaignRes.json();

  // Time to purchase (days to transaction)
  const ttpRes = await fetch(
    `https://analyticsdata.googleapis.com/v1beta/properties/${propertyId}:runReport`,
    {
      method: 'POST', headers,
      body: JSON.stringify({
        dateRanges: [dateRange],
        dimensions: [{ name: 'sessionCampaignName' }, { name: 'daysSinceLastSession' }],
        metrics: [{ name: 'transactions' }],
        dimensionFilter: {
          filter: { fieldName: 'daysSinceLastSession', stringFilter: { matchType: 'FULL_REGEXP', value: '[0-9]+' } }
        }
      })
    }
  );
  const ttpData = await ttpRes.json();

  return { campaignData, ttpData };
}

// ─── RENDER CAMPAIGNS ──────────────────────────────────────────────────────
function renderCampaignTab(campaignData, ttpData) {
  const rows = (campaignData.rows || []).filter(r => {
    const name = r.dimensionValues[0].value.toLowerCase();
    return name && name !== '(not set)' && name !== 'direct' && name.length > 1;
  });

  if (!rows.length) {
    document.getElementById('campaign-table').innerHTML = '<p style="color:var(--text-dim);font-size:0.72rem;padding:1rem 0">No campaign data yet — UTM parameters needed on ads. Check back in 7 days.</p>';
    ['new-vs-returning','time-to-purchase','bounce-by-campaign','express-gap'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = '<p style="color:var(--text-dim);font-size:0.72rem;padding:1rem 0">Awaiting UTM data</p>';
    });
    return;
  }

  // Campaign table
  const tableEl = document.getElementById('campaign-table');
  if (tableEl) {
    const headers = ['Campaign','Sessions','CVR','AOV','Rev/Session','Bounce','New Users'];
    let html = `<table style="width:100%;border-collapse:collapse;font-size:0.7rem;font-family:'DM Mono',monospace">
      <thead><tr>${headers.map(h => `<th style="text-align:left;padding:0.6rem 0.8rem;color:var(--text-dim);font-size:0.6rem;letter-spacing:0.1em;text-transform:uppercase;border-bottom:1px solid var(--border)">${h}</th>`).join('')}</tr></thead><tbody>`;

    rows.forEach(row => {
      const name = row.dimensionValues[0].value;
      const sessions = parseInt(row.metricValues[0].value) || 0;
      const transactions = parseInt(row.metricValues[1].value) || 0;
      const revenue = parseFloat(row.metricValues[2].value) || 0;
      const bounce = parseFloat(row.metricValues[3].value) || 0;
      const newUsers = parseInt(row.metricValues[4].value) || 0;
      const cvr = sessions > 0 ? ((transactions/sessions)*100).toFixed(1)+'%' : '—';
      const aov = transactions > 0 ? '£'+(revenue/transactions).toFixed(2) : '—';
      const rps = sessions > 0 ? '£'+(revenue/sessions).toFixed(2) : '—';
      const bounceStr = (bounce*100).toFixed(0)+'%';
      const newPct = sessions > 0 ? ((newUsers/sessions)*100).toFixed(0)+'%' : '—';
      const cvrNum = parseFloat(cvr);
      const cvrColor = cvrNum > 3 ? 'var(--green)' : cvrNum > 1.5 ? 'var(--amber)' : 'var(--red)';
      const bounceNum = parseFloat(bounceStr);
      const bounceColor = bounceNum > 60 ? 'var(--red)' : bounceNum > 40 ? 'var(--amber)' : 'var(--green)';

      html += `<tr style="border-bottom:1px solid var(--border)">
        <td style="padding:0.7rem 0.8rem;color:var(--gold)">${name}</td>
        <td style="padding:0.7rem 0.8rem">${sessions.toLocaleString()}</td>
        <td style="padding:0.7rem 0.8rem;color:${cvrColor};font-weight:500">${cvr}</td>
        <td style="padding:0.7rem 0.8rem">${aov}</td>
        <td style="padding:0.7rem 0.8rem;color:var(--green)">${rps}</td>
        <td style="padding:0.7rem 0.8rem;color:${bounceColor}">${bounceStr}</td>
        <td style="padding:0.7rem 0.8rem">${newPct}</td>
      </tr>`;
    });
    html += '</tbody></table>';
    tableEl.innerHTML = html;
  }

  // New vs Returning
  const nvrEl = document.getElementById('new-vs-returning');
  if (nvrEl) {
    let html = '';
    rows.forEach(row => {
      const name = row.dimensionValues[0].value;
      const sessions = parseInt(row.metricValues[0].value) || 0;
      const newUsers = parseInt(row.metricValues[4].value) || 0;
      const newPct = sessions > 0 ? Math.round((newUsers/sessions)*100) : 0;
      const retPct = 100 - newPct;
      html += `
        <div style="margin-bottom:1.2rem">
          <div style="display:flex;justify-content:space-between;margin-bottom:0.3rem">
            <span style="font-size:0.65rem;color:var(--text-dim);font-family:'DM Mono',monospace">${name}</span>
            <span style="font-size:0.65rem;color:var(--text-dim);font-family:'DM Mono',monospace">${newPct}% new · ${retPct}% returning</span>
          </div>
          <div style="height:8px;background:var(--surface2);position:relative">
            <div style="height:100%;width:${newPct}%;background:var(--gold);opacity:0.8"></div>
          </div>
        </div>`;
    });
    nvrEl.innerHTML = html || '<p style="color:var(--text-dim);font-size:0.72rem">No data yet</p>';
  }

  // Bounce by campaign
  const bounceEl = document.getElementById('bounce-by-campaign');
  if (bounceEl) {
    let html = '';
    rows.sort((a,b) => parseFloat(b.metricValues[3].value) - parseFloat(a.metricValues[3].value)).forEach(row => {
      const name = row.dimensionValues[0].value;
      const bounce = (parseFloat(row.metricValues[3].value)*100).toFixed(0);
      const color = bounce > 60 ? 'red' : bounce > 40 ? 'amber' : 'green';
      html += `
        <div class="funnel-step" style="margin-bottom:0.6rem">
          <div class="funnel-label">${name}</div>
          <div class="funnel-bar-wrap">
            <div class="funnel-bar ${color}" data-pct="${Math.min(bounce,100)}" style="width:0%">
              <span class="funnel-count">${bounce}%</span>
            </div>
          </div>
        </div>`;
    });
    bounceEl.innerHTML = html;
    setTimeout(() => {
      bounceEl.querySelectorAll('.funnel-bar').forEach(b => b.style.width = b.dataset.pct + '%');
    }, 200);
  }

  // Time to purchase
  const ttpEl = document.getElementById('time-to-purchase');
  if (ttpEl) {
    const ttpRows = ttpData.rows || [];
    const campaignDays = {};
    ttpRows.forEach(row => {
      const camp = row.dimensionValues[0].value;
      const days = parseInt(row.dimensionValues[1].value) || 0;
      const txns = parseInt(row.metricValues[0].value) || 0;
      if (!campaignDays[camp]) campaignDays[camp] = { totalDays: 0, totalTxns: 0 };
      campaignDays[camp].totalDays += days * txns;
      campaignDays[camp].totalTxns += txns;
    });

    let html = '';
    Object.entries(campaignDays).filter(([k]) => k && k !== '(not set)').forEach(([camp, d]) => {
      const avg = d.totalTxns > 0 ? (d.totalDays / d.totalTxns).toFixed(1) : '—';
      const color = parseFloat(avg) <= 1 ? 'var(--green)' : parseFloat(avg) <= 3 ? 'var(--amber)' : 'var(--red)';
      html += `<div class="metric-row">
        <span class="metric-key">${camp}</span>
        <span class="metric-val" style="color:${color}">${avg} days avg</span>
      </div>`;
    });
    ttpEl.innerHTML = html || '<p style="color:var(--text-dim);font-size:0.72rem">Awaiting data</p>';
  }

  // Express vs Standard CVR gap (sample until express tracking data flows)
  const gapEl = document.getElementById('express-gap');
  if (gapEl) {
    gapEl.innerHTML = `
      <div style="font-size:0.7rem;color:var(--text-dim);line-height:1.8;padding:0.5rem 0">
        Express checkout click data is accumulating from the tracking scripts installed today.
        This panel will show express vs standard CVR per campaign once sufficient data is available (approx 7 days).
      </div>
      <div class="metric-row" style="margin-top:0.5rem">
        <span class="metric-key">Overall express rate</span>
        <span class="metric-val good">80%</span>
      </div>`;
  }
}

// ─── PATCH fetchGA4Data TO ALSO FETCH CAMPAIGN DATA ────────────────────────
const _origFetchGA4Data = fetchGA4Data;
fetchGA4Data = async function() {
  await _origFetchGA4Data();

  // Also fetch campaign data if campaigns tab exists
  const campTab = document.getElementById('tab-campaigns');
  if (!campTab) return;

  const dateRange = FILTERS.startDate && FILTERS.endDate
    ? { startDate: FILTERS.startDate, endDate: FILTERS.endDate }
    : { startDate: `${FILTERS.days || 30}daysAgo`, endDate: 'today' };

  try {
    const tokenRes = await fetch(NETLIFY_FUNCTION_URL);
    const tokenData = await tokenRes.json();
    if (!tokenData.access_token) return;
    const { campaignData, ttpData } = await fetchCampaignData(tokenData.access_token, dateRange);
    renderCampaignTab(campaignData, ttpData);
  } catch(e) {
    console.error('Campaign fetch error:', e);
  }
};

// ─── ORDERS TAB ────────────────────────────────────────────────────────────
async function fetchOrdersData(token, dateRange) {
  const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
  const propertyId = GA4_PROPERTY_ID;

  // Weekly orders and revenue
  const weeklyRes = await fetch(
    `https://analyticsdata.googleapis.com/v1beta/properties/${propertyId}:runReport`,
    {
      method: 'POST', headers,
      body: JSON.stringify({
        dateRanges: [dateRange],
        dimensions: [{ name: 'week' }],
        metrics: [
          { name: 'transactions' },
          { name: 'purchaseRevenue' },
        ],
        orderBys: [{ dimension: { dimensionName: 'week' } }]
      })
    }
  );
  const weeklyData = await weeklyRes.json();

  // Box size split via item name
  const sizeRes = await fetch(
    `https://analyticsdata.googleapis.com/v1beta/properties/${propertyId}:runReport`,
    {
      method: 'POST', headers,
      body: JSON.stringify({
        dateRanges: [dateRange],
        dimensions: [{ name: 'itemName' }],
        metrics: [
          { name: 'itemsPurchased' },
          { name: 'itemRevenue' },
        ],
      })
    }
  );
  const sizeData = await sizeRes.json();

  return { weeklyData, sizeData };
}

function renderOrdersTab(weeklyData, sizeData, totalOrders, totalRevenue, days) {
  // KPIs
  const aov = totalOrders > 0 ? (totalRevenue / totalOrders).toFixed(2) : 0;
  const perDay = days > 0 ? (totalOrders / days).toFixed(1) : 0;

  const ordTotal = document.getElementById('ord-total');
  const ordRevenue = document.getElementById('ord-revenue');
  const ordAov = document.getElementById('ord-aov');
  const ordPerDay = document.getElementById('ord-per-day');

  if (ordTotal) ordTotal.textContent = totalOrders.toLocaleString();
  if (ordRevenue) ordRevenue.textContent = '£' + fmtNum(Math.round(totalRevenue));
  if (ordAov) ordAov.textContent = '£' + aov;
  if (ordPerDay) ordPerDay.textContent = perDay;

  // Weekly charts
  const weekRows = weeklyData.rows || [];
  if (weekRows.length) {
    const weekLabels = weekRows.map(r => 'W' + r.dimensionValues[0].value.slice(-2));
    const weekOrders = weekRows.map(r => parseInt(r.metricValues[0].value) || 0);
    const weekRevenue = weekRows.map(r => Math.round(parseFloat(r.metricValues[1].value)) || 0);
    const weekAov = weekRows.map((r, i) => {
      const o = parseInt(r.metricValues[0].value) || 0;
      const rev = parseFloat(r.metricValues[1].value) || 0;
      return o > 0 ? Math.round(rev / o) : 0;
    });

    renderBarChart('orders-weekly-chart', weekOrders, weekLabels, '');
    renderBarChart('revenue-weekly-chart', weekRevenue, weekLabels, '£');
    renderBarChart('aov-weekly-chart', weekAov, weekLabels, '£');
  }

  // Box size split
  const splitEl = document.getElementById('box-size-split');
  if (splitEl) {
    const rows = sizeData.rows || [];
    let bab6 = 0, bab12 = 0, disc = 0, other = 0;
    rows.forEach(row => {
      const name = row.dimensionValues[0].value.toLowerCase();
      const qty = parseInt(row.metricValues[0].value) || 0;
      if (name.includes('6') || (name.includes('build') && !name.includes('12'))) bab6 += qty;
      else if (name.includes('12')) bab12 += qty;
      else if (name.includes('discovery')) disc += qty;
      else other += qty;
    });
    const total = bab6 + bab12 + disc + other || 1;
    const items = [
      { label: 'Build a Box — 6 bars', count: bab6, color: 'var(--gold)' },
      { label: 'Build a Box — 12 bars', count: bab12, color: 'var(--amber)' },
      { label: 'Discovery Box', count: disc, color: 'var(--green)' },
    ].filter(i => i.count > 0);

    splitEl.innerHTML = items.map(item => {
      const pct = Math.round((item.count / total) * 100);
      return `
        <div style="margin-bottom:1rem">
          <div style="display:flex;justify-content:space-between;margin-bottom:0.3rem">
            <span style="font-size:0.65rem;color:var(--text-dim);font-family:'DM Mono',monospace">${item.label}</span>
            <span style="font-size:0.65rem;color:var(--text-dim);font-family:'DM Mono',monospace">${item.count.toLocaleString()} orders · ${pct}%</span>
          </div>
          <div style="height:8px;background:var(--surface2)">
            <div style="height:100%;width:${pct}%;background:${item.color};transition:width 0.4s ease"></div>
          </div>
        </div>`;
    }).join('') || '<p style="color:var(--text-dim);font-size:0.72rem">No order data yet</p>';
  }
}

function renderBarChart(id, values, labels, prefix) {
  const el = document.getElementById(id);
  if (!el || !values.length) return;
  const max = Math.max(...values) || 1;
  el.innerHTML = values.map((v, i) => `
    <div class="chart-bar-col">
      <div class="chart-bar" data-h="${(v/max)*140}" style="height:0px" title="${prefix}${v.toLocaleString()}"></div>
      <div class="chart-label">${labels[i]}</div>
    </div>`).join('');
  setTimeout(() => {
    el.querySelectorAll('.chart-bar').forEach(b => { b.style.height = b.dataset.h + 'px'; });
  }, 300);
}

// ─── PATCH fetchGA4Data TO ALSO FETCH ORDERS DATA ──────────────────────────
const _origFetchGA4Data2 = fetchGA4Data;
fetchGA4Data = async function() {
  await _origFetchGA4Data2();

  const ordersTab = document.getElementById('tab-orders');
  if (!ordersTab) return;

  const dateRange = FILTERS.startDate && FILTERS.endDate
    ? { startDate: FILTERS.startDate, endDate: FILTERS.endDate }
    : { startDate: `${FILTERS.days || 30}daysAgo`, endDate: 'today' };

  try {
    const tokenRes = await fetch(NETLIFY_FUNCTION_URL);
    const tokenData = await tokenRes.json();
    if (!tokenData.access_token) return;
    const token = tokenData.access_token;

    const { weeklyData, sizeData } = await fetchOrdersData(token, dateRange);

    // Get totals from already-fetched session data
    const sessionRes = await fetch(
      `https://analyticsdata.googleapis.com/v1beta/properties/${GA4_PROPERTY_ID}:runReport`,
      {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          dateRanges: [dateRange],
          dimensions: [],
          metrics: [{ name: 'transactions' }, { name: 'purchaseRevenue' }],
        })
      }
    );
    const sessionData = await sessionRes.json();
    const row = sessionData.rows && sessionData.rows[0];
    const totalOrders = row ? parseInt(row.metricValues[0].value) : 0;
    const totalRevenue = row ? parseFloat(row.metricValues[1].value) : 0;
    const days = FILTERS.days || 30;

    renderOrdersTab(weeklyData, sizeData, totalOrders, totalRevenue, days);
  } catch(e) {
    console.error('Orders fetch error:', e);
  }
};

// ─── BAR SALES TAB ─────────────────────────────────────────────────────────

// Fixed Discovery Box recipes
const DISC_RECIPE_6 = {
  'Caramel': 1, 'Hazelnut': 1, 'Malt Cornflakes': 1,
  'Peanut Butter': 1, 'Raspberry': 1, 'Pistachio': 1
};
const DISC_RECIPE_12 = {
  'Caramel': 2, 'Hazelnut': 2, 'Malt Cornflakes': 2,
  'Peanut Butter': 2, 'Raspberry': 2, 'Pistachio': 2
};

const FLAVOUR_COLOURS = {
  'Caramel':       'var(--gold)',
  'Hazelnut':      'var(--amber)',
  'Malt Cornflakes': '#a0785a',
  'Peanut Butter': '#c4a35a',
  'Raspberry':     'var(--red)',
  'Pistachio':     'var(--green)',
  'Orange':        '#e07a2f',
  'Special':       'var(--text-dim)',
};

async function fetchBarSalesData(token, dateRange) {
  const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
  const propertyId = GA4_PROPERTY_ID;

  // Fetch bab_purchase custom events with flavour params
  const babRes = await fetch(
    `https://analyticsdata.googleapis.com/v1beta/properties/${propertyId}:runReport`,
    {
      method: 'POST', headers,
      body: JSON.stringify({
        dateRanges: [dateRange],
        dimensions: [{ name: 'eventName' }, { name: 'customEvent:bar_caramel' }],
        metrics: [{ name: 'eventCount' }],
        dimensionFilter: {
          filter: { fieldName: 'eventName', stringFilter: { matchType: 'EXACT', value: 'bab_purchase' } }
        }
      })
    }
  );

  // Fetch all bab_purchase event params via custom dimensions
  const flavours = ['caramel','hazelnut','malt_cornflakes','peanut_butter','raspberry','pistachio','orange','special'];
  const babFlavourData = {};

  await Promise.all(flavours.map(async (flavour) => {
    const res = await fetch(
      `https://analyticsdata.googleapis.com/v1beta/properties/${propertyId}:runReport`,
      {
        method: 'POST', headers,
        body: JSON.stringify({
          dateRanges: [dateRange],
          dimensions: [{ name: `customEvent:bar_${flavour}` }],
          metrics: [{ name: 'eventCount' }],
          dimensionFilter: {
            filter: { fieldName: 'eventName', stringFilter: { matchType: 'EXACT', value: 'bab_purchase' } }
          }
        })
      }
    );
    const data = await res.json();
    let total = 0;
    (data.rows || []).forEach(row => {
      const qty = parseInt(row.dimensionValues[0].value) || 0;
      const count = parseInt(row.metricValues[0].value) || 0;
      total += qty * count;
    });
    babFlavourData[flavour] = total;
  }));

  // Fetch Discovery Box order counts (item-level)
  const discRes = await fetch(
    `https://analyticsdata.googleapis.com/v1beta/properties/${propertyId}:runReport`,
    {
      method: 'POST', headers,
      body: JSON.stringify({
        dateRanges: [dateRange],
        dimensions: [{ name: 'itemName' }],
        metrics: [{ name: 'itemsPurchased' }],
        dimensionFilter: {
          orGroup: {
            expressions: [
              { filter: { fieldName: 'itemName', stringFilter: { matchType: 'CONTAINS', value: 'Discovery' } } },
              { filter: { fieldName: 'itemName', stringFilter: { matchType: 'CONTAINS', value: 'discovery' } } },
            ]
          }
        }
      })
    }
  );
  const discData = await discRes.json();

  return { babFlavourData, discData };
}

function renderBarSalesTab(babFlavourData, discData) {
  // Calculate Discovery Box bar counts
  const discFlavours = {};
  const discRows = discData.rows || [];

  discRows.forEach(row => {
    const name = row.dimensionValues[0].value.toLowerCase();
    const qty = parseInt(row.metricValues[0].value) || 0;
    const recipe = name.includes('12') ? DISC_RECIPE_12 : DISC_RECIPE_6;
    Object.entries(recipe).forEach(([flavour, count]) => {
      discFlavours[flavour] = (discFlavours[flavour] || 0) + (count * qty);
    });
  });

  // Normalise BAB flavour keys to display names
  const nameMap = {
    'caramel': 'Caramel', 'hazelnut': 'Hazelnut', 'malt_cornflakes': 'Malt Cornflakes',
    'peanut_butter': 'Peanut Butter', 'raspberry': 'Raspberry', 'pistachio': 'Pistachio',
    'orange': 'Orange', 'special': 'Special'
  };

  const babFlavours = {};
  Object.entries(babFlavourData).forEach(([key, val]) => {
    if (val > 0) babFlavours[nameMap[key] || key] = val;
  });

  // Combine totals — respect product filter
  const pf = FILTERS.product;
  const combined = {};
  const allFlavours = new Set([...Object.keys(babFlavours), ...Object.keys(discFlavours)]);
  allFlavours.forEach(f => {
    const babVal = pf === 'disc' ? 0 : (babFlavours[f] || 0);
    const discVal = pf === 'bab' ? 0 : (discFlavours[f] || 0);
    const total = babVal + discVal;
    if (total > 0) combined[f] = total;
  });

  const totalBars = Object.values(combined).reduce((a, b) => a + b, 0);
  const totalBab = pf === 'disc' ? 0 : Object.values(babFlavours).reduce((a, b) => a + b, 0);
  const totalDisc = pf === 'bab' ? 0 : Object.values(discFlavours).reduce((a, b) => a + b, 0);
  const topFlavour = Object.entries(combined).sort((a, b) => b[1] - a[1])[0];

  // KPIs
  const elTotal = document.getElementById('bars-total');
  const elTop = document.getElementById('bars-top');
  const elBab = document.getElementById('bars-bab-total');
  const elDisc = document.getElementById('bars-disc-total');
  if (elTotal) elTotal.textContent = totalBars.toLocaleString();
  if (elTop) elTop.textContent = topFlavour ? topFlavour[0] : '—';
  if (elBab) elBab.textContent = totalBab.toLocaleString();
  if (elDisc) elDisc.textContent = totalDisc.toLocaleString();

  // Combined rankings
  const rankingsEl = document.getElementById('flavour-rankings');
  if (rankingsEl) {
    const sorted = Object.entries(combined).sort((a, b) => b[1] - a[1]);
    const max = sorted[0] ? sorted[0][1] : 1;
    rankingsEl.innerHTML = sorted.length ? sorted.map(([flavour, count]) => {
      const pct = Math.round((count / max) * 100);
      const sharePct = totalBars > 0 ? ((count / totalBars) * 100).toFixed(1) : 0;
      const color = FLAVOUR_COLOURS[flavour] || 'var(--gold-dim)';
      return `
        <div class="funnel-step" style="margin-bottom:0.8rem">
          <div class="funnel-label" style="width:130px">${flavour}</div>
          <div class="funnel-bar-wrap">
            <div class="funnel-bar" data-pct="${pct}" style="width:0%;background:${color}">
              <span class="funnel-count">${count.toLocaleString()}</span>
            </div>
          </div>
          <div class="funnel-drop" style="width:60px;text-align:right;font-size:0.6rem;color:var(--text-dim)">${sharePct}%</div>
        </div>`;
    }).join('') : '<p style="color:var(--text-dim);font-size:0.72rem;padding:1rem 0">No bar sales data yet — tracking installed today, check back tomorrow.</p>';

    setTimeout(() => {
      rankingsEl.querySelectorAll('.funnel-bar').forEach(b => b.style.width = b.dataset.pct + '%');
    }, 200);
  }

  // BAB breakdown
  renderFlavourList('bab-flavour-breakdown', babFlavours, totalBab);

  // Discovery breakdown
  renderFlavourList('disc-flavour-breakdown', discFlavours, totalDisc);
}

function renderFlavourList(id, flavours, total) {
  const el = document.getElementById(id);
  if (!el) return;
  const sorted = Object.entries(flavours).sort((a, b) => b[1] - a[1]);
  if (!sorted.length) {
    el.innerHTML = '<p style="color:var(--text-dim);font-size:0.72rem">No data yet</p>';
    return;
  }
  el.innerHTML = sorted.map(([flavour, count]) => {
    const pct = total > 0 ? ((count / total) * 100).toFixed(1) : 0;
    return `<div class="metric-row">
      <span class="metric-key">${flavour}</span>
      <span class="metric-val" style="color:${FLAVOUR_COLOURS[flavour] || 'var(--gold)'}">${count.toLocaleString()} <span style="color:var(--text-dim);font-size:0.6rem">${pct}%</span></span>
    </div>`;
  }).join('');
}


// ─── AD IMAGE LOOKUP FROM ADCONFIGS ────────────────────────────────────────
const AD_IMAGES = {};

async function loadAdImages() {
  const configFiles = [
    '/assets/ad-config-craving.js',
    '/assets/ad-config-selftreat.js',
    '/assets/ad-config-habit.js',
    '/assets/ad-config-retargeting-craving.js',
    '/assets/ad-config-retargeting-nudge.js',
  ];

  // Temporarily capture adConfigs populated by the scripts
  window.adConfigs = window.adConfigs || {};
  const before = Object.keys(window.adConfigs);

  await Promise.all(configFiles.map(async (file) => {
    try {
      const res = await fetch(file);
      const text = await res.text();
      // Execute the script in current window context
      const script = document.createElement('script');
      script.textContent = text;
      document.head.appendChild(script);
      document.head.removeChild(script);
    } catch(e) {
      console.warn('Could not load config file:', file, e);
    }
  }));

  // Extract image URLs from all populated adConfigs
  Object.entries(window.adConfigs).forEach(([key, config]) => {
    if (config.image) {
      AD_IMAGES[key] = config.image;
    }
  });

  console.log('AD_IMAGES loaded:', Object.keys(AD_IMAGES).length, 'entries');
}

// ─── PATCH fetchGA4Data TO ALSO FETCH BAR SALES DATA ───────────────────────
const _origFetchGA4Data3 = fetchGA4Data;
fetchGA4Data = async function() {
  await _origFetchGA4Data3();

  const barsTab = document.getElementById('tab-bars');
  if (!barsTab) return;

  const dateRange = FILTERS.startDate && FILTERS.endDate
    ? { startDate: FILTERS.startDate, endDate: FILTERS.endDate }
    : { startDate: `${FILTERS.days || 30}daysAgo`, endDate: 'today' };

  try {
    const tokenRes = await fetch(NETLIFY_FUNCTION_URL);
    const tokenData = await tokenRes.json();
    if (!tokenData.access_token) return;
    const { babFlavourData, discData } = await fetchBarSalesData(tokenData.access_token, dateRange);
    renderBarSalesTab(babFlavourData, discData);
  } catch(e) {
    console.error('Bar sales fetch error:', e);
  }
};

// ─── UTM ANALYSIS ──────────────────────────────────────────────────────────
async function fetchAndRenderUTM(token, dateRange) {
  try {
    const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
    const metrics = [
      { name: 'sessions' },
      { name: 'transactions' },
      { name: 'purchaseRevenue' },
      { name: 'addToCarts' },
      { name: 'bounceRate' },
    ];

    const termRes = await fetch(
      `https://analyticsdata.googleapis.com/v1beta/properties/${GA4_PROPERTY_ID}:runReport`,
      {
        method: 'POST', headers,
        body: JSON.stringify({
          dateRanges: [dateRange],
          dimensions: [{ name: 'sessionManualTerm' }],
          metrics,
          dimensionFilter: {
            notExpression: {
              filter: {
                fieldName: 'sessionManualTerm',
                stringFilter: { matchType: 'EXACT', value: '(not set)' }
              }
            }
          },
          orderBys: [{ metric: { metricName: 'transactions' }, desc: true }],
          limit: 50,
        })
      }
    );
    const termData = await termRes.json();

    const contentRes = await fetch(
      `https://analyticsdata.googleapis.com/v1beta/properties/${GA4_PROPERTY_ID}:runReport`,
      {
        method: 'POST', headers,
        body: JSON.stringify({
          dateRanges: [dateRange],
          dimensions: [{ name: 'sessionManualAdContent' }],
          metrics,
          dimensionFilter: {
            notExpression: {
              filter: {
                fieldName: 'sessionManualAdContent',
                stringFilter: { matchType: 'EXACT', value: '(not set)' }
              }
            }
          },
          orderBys: [{ metric: { metricName: 'transactions' }, desc: true }],
          limit: 50,
        })
      }
    );
    const contentData = await contentRes.json();

    const campaignRes = await fetch(
      `https://analyticsdata.googleapis.com/v1beta/properties/${GA4_PROPERTY_ID}:runReport`,
      {
        method: 'POST', headers,
        body: JSON.stringify({
          dateRanges: [dateRange],
          dimensions: [{ name: 'sessionCampaignName' }],
          metrics,
          dimensionFilter: {
            notExpression: {
              filter: {
                fieldName: 'sessionCampaignName',
                stringFilter: { matchType: 'EXACT', value: '(not set)' }
              }
            }
          },
          orderBys: [{ metric: { metricName: 'transactions' }, desc: true }],
          limit: 20,
        })
      }
    );
    const campaignData = await campaignRes.json();

    renderUTMTab(termData, contentData, campaignData);
  } catch(e) {
    console.error('UTM fetch error:', e);
  }
}

function renderUTMTable(containerId, rows, dimensionLabel) {
  const el = document.getElementById(containerId);
  if (!el) return;

  if (!rows || !rows.length) {
    el.innerHTML = '<p style="color:var(--text-dim);font-size:0.72rem;padding:1rem 0">No UTM data yet — check back once ads have been running for 24-48 hours.</p>';
    return;
  }

  const headers = [dimensionLabel, 'Sessions', 'CVR', 'Orders', 'Revenue', 'AOV', 'ATC', 'Bounce'];
  let html = `
    <table style="width:100%;border-collapse:collapse;font-size:0.68rem;font-family:'DM Mono',monospace">
      <thead>
        <tr>${headers.map(h => `
          <th style="text-align:left;padding:0.6rem 0.8rem;color:var(--text-dim);font-size:0.58rem;letter-spacing:0.1em;text-transform:uppercase;border-bottom:1px solid var(--border)">${h}</th>
        `).join('')}</tr>
      </thead>
      <tbody>`;

  rows.forEach(row => {
    const dim = row.dimensionValues[0].value;
    const sessions = parseInt(row.metricValues[0].value) || 0;
    const orders = parseInt(row.metricValues[1].value) || 0;
    const revenue = parseFloat(row.metricValues[2].value) || 0;
    const atc = parseInt(row.metricValues[3].value) || 0;
    const bounce = (parseFloat(row.metricValues[4].value) * 100).toFixed(0);

    const cvr = sessions > 0 ? ((orders / sessions) * 100).toFixed(2) + '%' : '—';
    const aov = orders > 0 ? '£' + (revenue / orders).toFixed(2) : '—';
    const cvrNum = parseFloat(cvr);
    const cvrColor = cvrNum > 3 ? 'var(--green)' : cvrNum > 1.5 ? 'var(--amber)' : cvrNum > 0 ? 'var(--red)' : 'var(--text-dim)';
    const bounceColor = parseInt(bounce) > 60 ? 'var(--red)' : parseInt(bounce) > 40 ? 'var(--amber)' : 'var(--green)';
    const revColor = revenue > 0 ? 'var(--green)' : 'var(--text-dim)';

    const imgUrl = AD_IMAGES[dim];
    const imgHtml = imgUrl
      ? `<img src="${imgUrl}" style="width:44px;height:44px;object-fit:cover;border-radius:2px;margin-right:0.6rem;vertical-align:middle;flex-shrink:0;">`
      : `<div style="width:44px;height:44px;background:var(--surface2);border-radius:2px;margin-right:0.6rem;display:inline-block;vertical-align:middle;flex-shrink:0;"></div>`;

    html += `
      <tr style="border-bottom:1px solid var(--border)">
        <td style="padding:0.5rem 0.8rem;max-width:280px">
          <div style="display:flex;align-items:center">
            ${imgHtml}
            <span style="color:var(--gold);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:0.65rem" title="${dim}">${dim}</span>
          </div>
        </td>
        <td style="padding:0.7rem 0.8rem">${sessions.toLocaleString()}</td>
        <td style="padding:0.7rem 0.8rem;color:${cvrColor};font-weight:500">${cvr}</td>
        <td style="padding:0.7rem 0.8rem">${orders}</td>
        <td style="padding:0.7rem 0.8rem;color:${revColor}">£${revenue.toFixed(2)}</td>
        <td style="padding:0.7rem 0.8rem">${aov}</td>
        <td style="padding:0.7rem 0.8rem">${atc}</td>
        <td style="padding:0.7rem 0.8rem;color:${bounceColor}">${bounce}%</td>
      </tr>`;
  });

  html += '</tbody></table>';
  el.innerHTML = html;
}

function renderUTMTab(termData, contentData, campaignData) {
  renderUTMTable('utm-term-table', termData.rows, 'Angle (utm_term)');
  renderUTMTable('utm-content-table', contentData.rows, 'Ad (utm_content)');
  renderUTMTable('utm-campaign-table', campaignData.rows, 'Campaign (utm_campaign)');

  const termRows = termData.rows || [];
  const contentRows = contentData.rows || [];
  const campaignRows = campaignData.rows || [];

  if (campaignRows.length) {
    document.getElementById('utm-top-source').textContent = campaignRows[0].dimensionValues[0].value;
  }
  if (termRows.length) {
    document.getElementById('utm-top-term').textContent = termRows[0].dimensionValues[0].value;
  }
  if (contentRows.length) {
    document.getElementById('utm-top-content').textContent = contentRows[0].dimensionValues[0].value;

    const bestCvr = contentRows
      .filter(r => parseInt(r.metricValues[0].value) > 10)
      .sort((a, b) => {
        const cvrA = parseInt(a.metricValues[1].value) / (parseInt(a.metricValues[0].value) || 1);
        const cvrB = parseInt(b.metricValues[1].value) / (parseInt(b.metricValues[0].value) || 1);
        return cvrB - cvrA;
      })[0];

    if (bestCvr) {
      document.getElementById('utm-best-cvr').textContent = bestCvr.dimensionValues[0].value;
    }
  }
}

// ─── PATCH fetchGA4Data TO ALSO FETCH UTM DATA ─────────────────────────────
const _origFetchGA4Data4 = fetchGA4Data;
fetchGA4Data = async function() {
  await _origFetchGA4Data4();

  const utmTab = document.getElementById('tab-utm');
  if (!utmTab) return;

  const dateRange = FILTERS.startDate && FILTERS.endDate
    ? { startDate: FILTERS.startDate, endDate: FILTERS.endDate }
    : { startDate: `${FILTERS.days || 30}daysAgo`, endDate: 'today' };

  try {
    const tokenRes = await fetch(NETLIFY_FUNCTION_URL);
    const tokenData = await tokenRes.json();
    if (!tokenData.access_token) return;
    await fetchAndRenderUTM(tokenData.access_token, dateRange);
  } catch(e) {
    console.error('UTM fetch error:', e);
  }
};